import { Component, OnInit, OnDestroy, ViewEncapsulation, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import {
    style,
    animate,
    transition,
    trigger,
    state,
    keyframes,
    group,
    animateChild,
    query as q
} from '@angular/animations';
export function query(s, a, o = {optional: true}) {
    return q(s, a, o);
}

import { Tutorial, LocalStorageService } from '../../core/upgraded-providers';

declare const fbq: any;

const tutorialTransition = trigger('tutorialTransition', [
    state('true', style({ opacity: 0.7, transform: 'translateX(160px) scale(1.2)' })),
    state('false', style({ opacity: 1, transform: 'translateX(0px) scale(1)' })),

    transition('false => true', group([
        query(':self', [
            animate('1300ms 0s ease', keyframes([
                style({transform: 'translateX(160px) scale(1)', offset: 0.3}),
                style({opacity: 0.7, transform: 'translateX(160px) scale(1.2)', offset: 0.9}),
                style({opacity: 0.7, transform: 'translateX(160px) scale(1.2)', offset: 1.0})
            ]))
        ]),
        query('@tutorialFigureTransition', [ animateChild() ]),
        query('@tutorialTextTransition', [ animateChild() ]),
    ])),
    transition('true => false', group([
        query(':self', [
            animate('1300ms 0s ease', keyframes([
                style({opacity: 0.7, transform: 'translateX(160px) scale(1.2)', offset: 0.1}),
                style({opacity: 0.7, transform: 'translateX(160px) scale(1)', offset: 0.7}),
                style({transform: 'translateX(0px) scale(1)', offset: 1})
            ]))
        ]),
        query('@tutorialFigureTransition', [ animateChild() ]),
        query('@tutorialTextTransition', [ animateChild() ]),
    ])),

]);

const tutorialFigureTransition = trigger('tutorialFigureTransition', [
    state('true', style({ marginBottom: '-26px' })),
    state('false', style({ marginBottom: '0px' })),
    transition('false => true', animate('300ms 300ms ease', keyframes([
        style({marginBottom: '0px', offset: 0.3}),
        style({marginBottom: '-26px', offset: 0.9}),
        style({marginBottom: '-26px', offset: 1.0})
    ]))),
    transition('true => false', animate('300ms 300ms ease', keyframes([
        style({marginBottom: '-26px', offset: 0.1}),
        style({marginBottom: '0px', offset: 0.7}),
        style({marginBottom: '0px', offset: 1})
    ])))
]);

const tutorialTextTransition = trigger('tutorialTextTransition', [
    state('true', style({ transform: 'scale(.9)' })),
    state('false', style({ transform: 'scale(1)' })),
    transition('false => true', animate('300ms 300ms ease', keyframes([
        style({transform: 'scale(1)', offset: 0.3}),
        style({transform: 'scale(.9)', offset: 0.9}),
        style({transform: 'scale(.9)', offset: 1.0})
    ]))),
    transition('true => false', animate('300ms 300ms ease', keyframes([
        style({transform: 'scale(.9)', offset: 0.1}),
        style({transform: 'scale(1)', offset: 0.7}),
        style({transform: 'scale(1)', offset: 1})
    ])))
]);

const modeTransition = trigger('modeTransition', [
    state('true', style({ opacity: '0', transform: 'translate(40px)' })),
    state('false', style({ opacity: '1', transform: 'translate(0px)' })),
    transition('false => true', animate('500ms 0s ease', keyframes([
        style({opacity: 1, offset: 0 }),
        style({opacity: 0, transform: 'translate(40px)', offset: 1})
    ]))),
    transition('true => false', animate('1500ms 0s ease', keyframes([
        style({opacity: 0, transform: 'translate(40px)', offset: 0.7}),
        style({opacity: 1, transform: 'translate(0px)', offset: 1})
    ])))
]);

const backTransition = trigger('backTransition', [
    state('true', style({ opacity: '1' })),
    state('false', style({ opacity: '0', display: 'none' })),
    transition('false => true', animate('500ms 0s ease')),
    transition('true => false', animate('500ms 0s ease'))
]);

@Component({
    selector: 'app-simulation-mode',
    templateUrl: './base.component.pug',
    styleUrls: ['./base.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        tutorialTransition,
        tutorialFigureTransition,
        tutorialTextTransition,
        modeTransition,
        backTransition
    ]
})
export class BaseComponent implements OnInit, OnDestroy {

    public isAnimateTutorial = false;
    public subscribers$;

    @HostBinding('class.anonymous') isAnonymous: boolean = false;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        private _tutorial: Tutorial,
        private _localStorage: LocalStorageService
    ) {
        if (!this._localStorage.get('tutorialVisited', false)) {
            this._localStorage.put('tutorialVisited', true);
            fbq('track', 'Lead');
        }

        this.isAnonymous = !!parseInt(this.route.snapshot.queryParams.anonymous, 10);
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    animateTutorial() {
        this.isAnimateTutorial = true;
    }

    onActivate(componentRef) {
        if (this.isAnimateTutorial && componentRef.animateTutorial) {
            componentRef.animateTutorial(true);
        }
    }
}
